import { useRole } from '@/hooks/UseRole';
import { useTranslation } from 'react-i18next';

export const useRoleOptions = () => {
  const { t } = useTranslation();
  const isAdmin = useRole('admin');

  const baseRoles = [
    { value: 'user', label: t('common:roles.user') },
    { value: 'manager', label: t('common:roles.manager') },
  ];

  return isAdmin
    ? [...baseRoles, { value: 'admin', label: t('common:roles.admin') }]
    : baseRoles;
};
